// Route constants
export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    ABOUT_US: '/about-us',
    CONTACT_US: '/contact-us',
    // Tender related routes
    TENDERS: '/tenders',
    TENDER_DETAIL: '/tenders/:tender_uuid',
    TENDERS_BY_KEYWORDS: '/tenders/keywords',
    TENDERS_BY_CATEGORY: '/tenders/category',
    TENDERS_BY_COUNTRY: '/tenders/country',
    TENDERS_BY_POLITICAL_REGION: '/tenders/political-region',
    TENDERS_BY_GEO_REGION: '/tenders/geo-region',
    TENDERS_FUNDING_AGENCIES: '/tenders/funding-agencies',
    TENDERS_LIVE: '/tenders/live',
    TENDERS_ARCHIVED: '/tenders/live?tender_type=Close',
    ARCHIVED_TENDERS: '/tenders/live?tender_type=Close',
    PUBLIC_ARCHIVED_TENDERS: '/tenders?tender_type=Close',
    TENDERS_PRIVATE: '/tenders/p',
    TENDERS_PRIVATE_DETAIL: '/tenders/p/:tender_uuid',
    TENDER_DOCUMENT: '/tender-doc/:tender_uuid',
    // Contract related routes
    CONTRACTS: '/contracts',
    CONTRACT_DETAILS: '/contracts/:contract_uuid',
    CONTRACTS_PRIVATE: '/contracts/p',
    CONTRACTS_PRIVATE_DETAIL: '/contracts/p/:contract_uuid',
    // Other routes
    SUBSCRIBE: '/subscribe',
    ADVANCED_SEARCH: '/advanced-search',
    ADVANCED_SEARCH_LIVE: '/tenders/advanced-search',
    TERMS_AND_CONDITIONS: '/terms-and-conditions',
    PRIVACY_POLICY: '/privacy-policy',
    REFUND_POLICY: '/refund-policy',
    DASHBOARD: '/dashboard',
    ANALYTIC_DASHBOARD: '/analytics',
    PROFILE: '/profile',
    RESET_PASSWORD: '/reset-password',
    CHANGE_PASSWORD: '/change-password',
    UPDATE_QUERY: '/update-query',
    LOGOUT: '/logout',
    NOTIFICATIONS: '/notifications',
    SITE_MAP: '/sitemap',
    SEARCH_ENGINE_FOR_TENDERS: '/search-engine-for-tenders',
    FAQ: '/faq',
    BLOG: '/blog',
    BLOG_DETAIL: '/blogs/:id',
    SEARCH_ENGINE_FOR_BIDS: '/search-engine-for-bids',
    EXPORT_TO_EXCEL: '/export',
    FORGOT_PASSWORD: '/forgot-password',
    EMAIL_TENDERS: '/email-tenders',
    TENDER_DATABASES: '/largest-tender-databases',
    FAVOURITE_TENDERS: '/favourite-tenders',
    TENDERING_PLATFORM: '/global-e-tendering-platform',
    EXTENSIVE_PROCUREMENT_DATABASE: '/extensive-procurement-database',
    SUBSCRIBE_PAYMENT: '/subscribe/:lead_id/payment',
    PAYMENT_SUCCESS: '/payment/success',
    PAYMENT_CANCEL: '/payment/cancel',
    PAYMENT_FAILURE: '/payment/failure',
    LATEST_GLOBAL_TENDERS: '/latest-global-tenders',
    LEADING_GLOBAL_TENDERING_PLATFORM: '/leading-global-tendering-platform',
    BID_CONSULTANCY_SERVICE: '/bid-consultancy-service',
    GOVERMENT_AND_PRIVATE_BIDS: '/find-government-and-private-Bids-online',
    THANK_YOU: '/thank-you',
    PUBLISH_TENDER: '/publish-tender',
    REQUEST_DEMO: '/request-demo',
    EUROPE_GOVERNMENT_TENDERS: '/europe-government-tenders-and-procurement-opportunities',
    EUROPE_GOVERNMENT_TENDERS_ALT: '/europe-government-tenders-&-procurement-opportunities',
    REGISTER_FREE_SAMPLE: '/register-free-sample',
    DAILY_TENDER_ALERTS: '/daily-tender-alerts',
    POLAND_GOVERNMENT_TENDERS: '/poland-government-tenders-and-procurement-opportunities',
    POLAND_GOVERNMENT_TENDERS_ALT: '/poland-government-tenders-&-procurement-opportunities',
    IT_SOFTWARE_TENDERS: '/it-software-government-tenders-and-procurement-opportunities',
    ERP_TENDERS: '/erp-government-tenders-and-procurement-opportunities',
    ENGINEERING_CONSULTANCY_TENDERS: '/engineering-consultancy-tenders-and-procurement-opportunities',
    ENVIRONMENTAL_CONSULTANCY_TENDERS: '/environmental-consultancy-tenders-and-procurement-opportunities',
    HEALTHCARE_TENDERS: '/healthcare-government-tenders-and-procurement-opportunities',
    CYBERSECURITY_TENDERS: '/cybersecurity-government-tenders-and-procurement-opportunities',
    GIS_GEOSPATIAL_TENDERS: '/gis-geospatial-tenders-and-procurement-opportunities',
    CONSTRUCTION_TENDERS: '/construction-government-tenders-and-procurement-opportunities',
    RENEWABLE_ENERGY_TENDERS: '/renewable-energy-tenders-and-procurement-opportunities',
    SOLAR_TENDERS: '/solar-energy-tenders-and-procurement-opportunities',
    OIL_GAS_TENDERS: '/oil-and-gas-tenders-and-procurement-opportunities',
    RAIL_METRO_TENDERS: '/rail-and-metro-tenders-and-procurement-opportunities',
    WATER_WASTEWATER_TENDERS: '/water-and-wastewater-tenders-and-procurement-opportunities',
    DEFENCE_TENDERS: '/defence-government-tenders-and-procurement-opportunities',
    DRONE_UAV_TENDERS: '/drone-and-uav-tenders-and-procurement-opportunities',
    SMART_CITY_TENDERS: '/smart-city-tenders-and-procurement-opportunities',
    TELECOM_TENDERS: '/telecom-government-tenders-and-procurement-opportunities',
    AI_DIGITAL_TRANSFORMATION_TENDERS: '/ai-digital-transformation-tenders-and-procurement-opportunities',
    CONTRACT_AWARDS_LANDING: '/contract-awards-and-procurement-results',
    WORLD_BANK_UN_TENDERS: '/world-bank-and-un-tenders-and-procurement-opportunities',
};